















































import { Component, Prop, Watch } from 'vue-property-decorator';
import { WxBaseWidget } from '../wxBaseWidget';
import { WxIBlobDataItem } from '../../../classes/wxDataDesc/wxIBlobDataItem';

@Component({ name: 'wxImageInputWidget' })
export default class WxImageInputWidget extends WxBaseWidget {
    @Prop(Boolean) private left?: boolean;
    @Prop(Boolean) private right?: boolean;
    @Prop(Boolean) private center?: boolean;
    @Prop(String) private width?: string;
    @Prop(String) private height?: string;
    @Prop(String) private aspectRatio?: string;
    @Prop(String) private placeholder?: string;
    @Prop(String) private placeholderIcon?: string;
    @Prop(String) private placeholderText?: string;
    @Prop(Boolean) private readonly noDeleteBtn?: boolean;
    @Prop(String) private deleteBtnText?: string;

    private lastImage?: string;

    private xSelfHeight = 0;
    private xSelfWidth = 0;

    private mounted() {
        setTimeout(() => {
            this.$nextTick(() => {
                if (this.xSelfHeight === 0 && this.xSelfWidth === 0) {
                    this.retrieveHeights();
                }
            });
        });
    }

    private updated() {
        if (this.xSelfHeight === 0 && this.xSelfWidth === 0) {
            this.retrieveHeights();
        }
    }

    private retrieveHeights() {
        const self = this.$refs.self as any;
        if (this.fillHeight) {
            this.xSelfHeight = self.offsetHeight;
        } else {
            this.xSelfWidth = self.offsetWidth;
        }
    }

    private get fillHeight() {
        return Number(this.computedAspectRatio) <= 1;
    }

    private get outerHeight() {
        return this.xSelfHeight !== 0 ? this.xSelfHeight - 60 : undefined;
    }

    private get outerWidth() {
        return this.xSelfWidth !== 0 ? this.xSelfWidth : undefined;
    }

    public get cssInnerVCard() {
        return {
            height: this.computedHeight + 8 + 'px',
            width: this.computedWidth + 8 + 'px',
        };
    }

    public get cssPlaceholderIcon() {
        return {
            height: this.computedHeight + 'px',
            width: this.computedWidth + 'px',
        };
    }

    public get computedHeight(): number {
        return this.height
            ? Number(this.height)
            : this.width && this.aspectRatio
            ? Number(this.width) / Number(this.aspectRatio)
            : this.outerWidth && this.aspectRatio
            ? Number(this.outerWidth) / Number(this.aspectRatio)
            : this.outerHeight
            ? this.outerHeight
            : 0;
    }

    public get computedWidth(): number {
        return this.width
            ? Number(this.width)
            : this.height && this.aspectRatio
            ? Number(this.height) * Number(this.aspectRatio)
            : this.outerHeight && this.aspectRatio
            ? Number(this.outerHeight) * Number(this.aspectRatio)
            : this.outerWidth
            ? this.outerWidth
            : 0;
    }

    public get computedAspectRatio() {
        return this.aspectRatio ? Number(this.aspectRatio) : this.height && this.width ? Number(this.width) / Number(this.height) : null;
    }

    public get rawImage() {
        return this.item[this.fieldName];
    }

    public get showDeleteButton() {
        return (
            !this.noDeleteBtn &&
            this.item[this.fieldName] &&
            this.item[this.fieldName] !== '' &&
            this.item[this.fieldName] !== '0' &&
            this.item[this.fieldName] !== '1'
        );
    }

    public get image() {
        if (this.item[this.fieldName] && this.item[this.fieldName] !== '1' && this.item[this.fieldName] !== '0') {
            return this.item[this.fieldName];
        } else if (this.placeholder) {
            return this.placeholder;
        } else {
            return '';
        }
    }

    @Watch('rawImage', { immediate: true })
    public onImageChanged(val: string) {
        if (val === '1') {
            const blobDataItem: WxIBlobDataItem = {
                CONTEXT: this.fieldName,
                REFERENCEGUID: null,
                CONTEXTNO: 0,
            };
            this.$emit('load-image', blobDataItem);
        }
    }

    public clearImage() {
        this.item[this.fieldName] = null;
    }

    public fileChanged(event: any) {
        const input = event.target;
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const regex = /^data:image\//gm;
                if (e && e.target && e.target.result && e.target.result.toString().match(regex)) {
                    this.lastImage = this.item[this.fieldName];
                    this.item[this.fieldName] = e.target.result;
                } else {
                    this.$store.commit('error', this.$t('$error.NO_VALID_PICTURE'));
                }
            };
            reader.readAsDataURL(input.files[0]);
        }
    }

    public hndlError() {
        if (this.lastImage) {
            this.item[this.fieldName] = this.lastImage;
            this.lastImage = undefined;
        }
    }
}
